import type { PreparedVoiceCommand } from '../types/LocalAiTypes';

export interface VoiceCommandEventDetail {
  intent: string;
  payload: Readonly<Record<string, unknown>>;
  stateToken?: string;
}

export function dispatchVoiceCommand(
  prepared: PreparedVoiceCommand,
  open: (address: string) => void,
): void {
  const action = prepared.uiAction;
  if (!action) return;
  const detail: VoiceCommandEventDetail = {
    intent: prepared.intent,
    payload: action.payload ?? prepared.resolvedParameters,
    ...(action.stateToken === undefined ? {} : { stateToken: action.stateToken }),
  };
  if ((action.type === 'navigate' || action.type === 'handoff') && action.route) open(action.route);

  if (prepared.intent === 'ui.focusSearch') {
    const search = document.querySelector<HTMLInputElement>('input[type="search"], input[role="searchbox"], .toolbar input');
    search?.focus();
  } else if (prepared.intent === 'ui.cancel') {
    document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
  }

  // Feature pages can implement fine-grained form actions without importing the voice subsystem.
  globalThis.setTimeout(() => {
    globalThis.dispatchEvent(new CustomEvent<VoiceCommandEventDetail>('varza:voice-command', { detail }));
  }, 0);
}
